module.exports = __webpack_public_path__ + "static/media/Activity (Active).7456de11.svg";